import { logDetailed } from "./utils";


function openPopupInWindow (url) { 
	return window.open(url, "_blank"); 
}

export function openPopup(url) {
	logDetailed("popup", "openPopup");
	if (window.openPopupInApp) window.openPopupInApp(url);
	else openPopupInWindow(url);
}